//  test V1: fit review section is visible 
//  test V2: fit review section is hidden - throught convert experience custom CSS code 

let productRatingFitReview = function(){
  if (document.querySelector("#product-fit-review  .okeReviews ")) {
    // make the true to size line thicker
    let fitWidgetSizeBar = document.querySelector("#product-fit-review .oke-w-header-content .oke-barBlocks--centered");
    if(fitWidgetSizeBar){
        let precentageText = document.querySelector("#product-fit-review .oke-w-header-content .oke-attrBar-title .oke-a11yText").innerText;
        if(precentageText.includes("0.0")){
            fitWidgetSizeBar.querySelector(".oke-barBlocks-bg-shading").style.setProperty("min-width", "30px", "important");
            fitWidgetSizeBar.querySelector(".oke-barBlocks-bg-shading").style.setProperty("transform", "translateX(-13px)", "important");
            fitWidgetSizeBar.querySelector(".oke-barBlocks-bg-centerLine").style.setProperty("background", "transparent", "important");
        }
    }

    // show the reviews count
    let fit_reviews_count = document.querySelector("#product-fit-review .fit-count");
    let product_count = document.querySelector("#product-fit-review .oke-w-navBar-item-count").innerText;
    product_count = Number(product_count.replace(/,/g, ''));
    if (product_count == 0) {
      return;
    }
    if (product_count == 1){
      fit_reviews_count.innerText = Number(product_count).toLocaleString() + " Review";
    }else {
      fit_reviews_count.innerText = Number(product_count).toLocaleString() + " Reviews";
    }
    document.querySelector("#product-fit-review").classList.remove("hidden");

  }
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => { productRatingFitReview(); }, 500);

  (function(){
    var GOAL="1004103050", KEY="conv_fit_seen_"+GOAL;
    if (sessionStorage.getItem(KEY)) return;
    function fire(){
      if (sessionStorage.getItem(KEY)) return;
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", GOAL]);
      sessionStorage.setItem(KEY,"1");
      console.log("✅ Fit review goal fired:", GOAL);
    }
    function onEl(sel, cb){
      var el = document.querySelector(sel);
      if (el) return cb(el);
      var mo = new MutationObserver(function(){
        var e = document.querySelector(sel);
        if (e){ mo.disconnect(); cb(e); }
      });
      mo.observe(document.documentElement,{childList:true,subtree:true});
    }
    onEl("#product-fit-review", function(target){
      var cur = target, anc = target.parentElement, child = target;
      while (cur && getComputedStyle(cur).display === "none"){
        child = cur;
        cur = cur.parentElement;
        if (!cur) break;
      }
      if (!cur || !cur.insertBefore) return;
      var sentinel = document.createElement("div");
      sentinel.setAttribute("data-fit-sentinel","");
      sentinel.style.cssText = "display:block;height:1px;width:1px;margin:0;padding:0;";
      try{ cur.insertBefore(sentinel, child); }catch(e){ return; }

      var fired=false;
      function done(){ fired=true; try{ io && io.disconnect(); }catch(e){} window.removeEventListener("scroll",check); window.removeEventListener("resize",check); }
      function check(){
        if (fired) return;
        var r = sentinel.getBoundingClientRect();
        if (r.top <= window.innerHeight*0.75 && r.bottom >= 0){ fire(); done(); }
      }
      var io;
      try{
        io = new IntersectionObserver(function(entries){
          if (fired) return;
          if (entries.some(function(en){ return en.isIntersecting; })){ fire(); done(); }
        },{root:null,rootMargin:"0px 0px -50% 0px",threshold:0});
        io.observe(sentinel);
      }catch(e){}
      window.addEventListener("scroll",check,{passive:true});
      window.addEventListener("resize",check);
      setTimeout(check,0);
    });
  })();
});


